module.exports = __webpack_public_path__ + "assets/img/new_categories_icon.5525435f.png";